import React from 'react';
import {
  Box, Tabs, TabList, TabPanels, Tab, TabPanel,
} from '@chakra-ui/react';
import TablaPanteones from './TablaPanteones';
import TablaLimpiezaPanteon from './TablaLimpiezaPanteon';

const Panteones: React.FC = () => {
  return (
    <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <Tabs colorScheme="red" variant="enclosed">
        <TabList>
          <Tab _selected={{ color: 'white', bg: '#5b182b' }}>Catálogo de Panteones</Tab>
          <Tab _selected={{ color: 'white', bg: '#5b182b' }}>Registros de Limpieza</Tab>
        </TabList>
        <TabPanels>
          <TabPanel px={0}><TablaPanteones /></TabPanel>
          <TabPanel px={0}><TablaLimpiezaPanteon /></TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default Panteones;
